import {CommonModule} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {ChangeDetectorRef, Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {catchError, of} from 'rxjs';
import {ConfigService} from 'src/app/services/config.service';
import {LoadingService} from 'src/app/services/loading.service';
import {LegalService} from "../../services/legal.service";

@Component({
  selector: 'connected-terms-of-service',
  standalone: true,
  templateUrl: './connected-terms-of-service.component.html',
  styleUrl: './connected-terms-of-service.component.scss',
  imports: [CommonModule]
})
export class ConnectedTermsOfServiceComponent {
  text: any;
  urlData: any;
  routerSubscriber: any;

  constructor(private http: HttpClient,
              private cdr: ChangeDetectorRef,
              private loadingService: LoadingService,
              private route: ActivatedRoute,
              private configService: ConfigService,
              private legalService: LegalService) {
  }

  ngOnInit() {
    this.loadingService.showLoading();
    this.routerSubscriber = this.route?.queryParams?.subscribe(params => {
      if (params && params['redirectUrl']) this.urlData = params['redirectUrl'];
    });
    this.http.get(this.legalService.getLegalDocument(this.urlData ? this.urlData : 'terms-service')).pipe(
      catchError((error) => {
        console.error('Error occurred:', error);
        this.loadingService.hideLoading();
        return of({});
      })
    ).subscribe((data: any) => {
      this.text = this.getText(data['copy']);
      this.loadingService.hideLoading();
      this.cdr.markForCheck();
    });
  }

  private getText(data: any) {
    if (data) {
      return decodeURIComponent(escape(atob(data)));
    }
    return ""
  }

  ngOnDestroy(){
    this.routerSubscriber.unsubscribe();
  }
}
